import './style.scss';
import { ResultHeader } from 'views/mutual/result';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { useSubUserAdd } from './hooks';
import { MessageModal } from 'views/mutual/modal/messageModal';
import { InputTemplate } from 'views/templates/module/inputTemplate';

export const SubUserAdd = () => {
  const { formik, modalProps } = useSubUserAdd();

  return (
    <>
      <div className="subUser">
        <div className="subUser_wrapper">
          <ResultHeader label="メールアドレス" />
          <div className="subUser_input">
            <InputTemplate
              type="text"
              placeholder="例: example@example.com"
              onChange={(value: string) => formik.setFieldValue('MailAddress', value)}
              value={formik.values.MailAddress}
              error={formik.submitCount > 0 ? formik.errors.MailAddress : undefined}
            />
          </div>
          <ResultHeader label="電話番号" />
          <div className="subUser_input">
            <InputTemplate
              type="tel"
              placeholder="例: 08000000000（ハイフンは不要です）"
              onChange={(value: string) => formik.setFieldValue('PhoneNumber', value)}
              value={formik.values.PhoneNumber}
              error={formik.submitCount > 0 ? formik.errors.PhoneNumber : undefined}
              maxLength={11}
            />
          </div>
        </div>
        <Button
          label="確認メールを送信"
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={formik.handleSubmit}
        />
      </div>
      <MessageModal {...modalProps} />
    </>
  );
};
